import { render, staticRenderFns } from "./PrintExercise.vue?vue&type=template&id=5812d7b6&"
import script from "./PrintExercise.vue?vue&type=script&lang=js&"
export * from "./PrintExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports